import { applyProps, Button } from 'ht-sdk/react';

export const ActionButton = applyProps(Button, {
	mode: 'secondary',
	size: 'sm',
});
